(() => {
  document.querySelectorAll('[data-hk-bkb]').forEach(root => {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';
    root.querySelectorAll('.hk-sizing__scroll').forEach(scroll => {
      const group = scroll.closest('.hk-sizing__group');
      const title = group?.querySelector('h3')?.textContent.trim() || 'Product';
      scroll.tabIndex = 0;
      scroll.setAttribute('role','region');
      scroll.setAttribute('aria-label',`${title} size chart`);
    });
    const config = JSON.parse(root.querySelector('[data-bkb-config]').textContent);
    const qty = root.querySelector('[data-bkb-quantity]');
    const variantSelect = root.querySelector('[data-bkb-variant]');
    const money = n => new Intl.NumberFormat('en-US', {style:'currency', currency:config.currency || 'USD'}).format(n);
    // Some legacy catalog labels contain UTF-8 punctuation decoded as Windows text.
    // Clean the display copy while keeping all IDs, choices and prices intact.
    const readable = value => String(value ?? '').replace(/\bresto\b/gi,'PTC').replaceAll('Ã—','x').replaceAll('â€”',' - ').replaceAll('â€“','-').replaceAll('â€™',"'").replaceAll('â€œ','"').replaceAll('â€\u009d','"').replaceAll('Â','');
    let lastValid = Number(qty.value);
    // Live product metafields remain authoritative when prices or available materials change.
    const packages = config.packages?.packages || (config.packageOverride ? JSON.parse(config.packageOverride)?.packages : null);
    const bindings = JSON.parse(config.variantBindings || '{}');
    let packageConfig = packages?.[0];
    const single = JSON.parse(config.singleChoices || '[]');
    let components = packageConfig?.components || [{label:'Fabric', choices:single}];
    const materialRoot = root.querySelector('[data-bkb-materials]');
    const controls = [];
    let styleSelect;
    if (packages?.length > 1) {
      const label=document.createElement('label'); styleSelect=document.createElement('select');
      styleSelect.id=qty.id+'-style';label.htmlFor=styleSelect.id;label.textContent='Style / construction';
      packages.forEach((p,i)=>{const option=document.createElement('option');option.value=String(i);option.textContent=readable(p.label);styleSelect.append(option);});
      materialRoot.before(label,styleSelect);
      styleSelect.addEventListener('change',()=>{setPackage(Number(styleSelect.value));update();});
    }
    function setPackage(index) {
      packageConfig=packages?.[index]; if(styleSelect)styleSelect.value=String(index);
      components=packageConfig?.components || [{label:'Fabric',choices:single}];
      materialRoot.replaceChildren();controls.length=0;buildControls();
      applyVariantBinding();
    }
    function applyVariantBinding(){const binding=bindings[variantSelect.value];if(binding&&controls[binding.component])controls[binding.component].value=String(binding.choice);}
    function buildControls(){
    components.forEach((component,index) => {
      const label = document.createElement('label');
      const select = document.createElement('select');
      select.id = `${qty.id}-material-${index}`;
      label.htmlFor = select.id;
      label.textContent = readable(component.label);
      (component.choices || []).forEach((choice,i) => {
        const option = document.createElement('option');
        option.value = String(i);
        option.textContent = readable(choice.label) + (choice.add > 0 ? ` (+${money(choice.add)} per ${packageConfig ? 'package' : 'item'})` : '');
        option.selected = !!choice.default;
        select.append(option);
      });
      materialRoot.append(label,select);
      controls.push(select);
      select.addEventListener('change',()=>{
        const matches=Object.entries(bindings).filter(([,b])=>b.component===index&&b.choice===Number(select.value));
        if(matches.length&&!matches.some(([id])=>id===variantSelect.value))variantSelect.value=matches[0][0];
        update();
      });
    });
    }
    buildControls();applyVariantBinding();
    function variantChanged(){
      const variant=config.variants.find(v=>String(v.id)===variantSelect.value);
      let index=packages?.findIndex(p=>p.sku===variant?.sku)??-1;
      if(packages?.length>1 && /zip/i.test(variant?.title||'')){
        const wantsZip=!/no zipper/i.test(variant.title);const found=packages.findIndex(p=>wantsZip?/with zips/i.test(p.label):!/with zips/i.test(p.label));if(found>=0)index=found;
      }
      if(index>=0&&packageConfig!==packages[index])setPackage(index);
      applyVariantBinding();update();
    }
    function tierPrice(quantity) {
      const list = packageConfig?.tiers || config.tiers || [];
      const found = list.find(t => {
        const numbers = t.units.match(/\d+/g)?.map(Number) || [];
        return quantity >= numbers[0] && (numbers.length < 2 || quantity <= numbers[1]);
      });
      if (!found || !/^\$?\d+(\.\d{2})?$/.test(found.price.trim())) return null;
      return Number(found.price.replace('$',''));
    }
    function update() {
      const count = Number(qty.value);
      const valid = qty.value.trim() !== '' && Number.isSafeInteger(count) && count >= config.minimum;
      if (valid) lastValid = count;
      qty.setCustomValidity(valid ? '' : `Minimum ${config.minimum}; whole quantities only.`);
      qty.setAttribute('aria-invalid', String(!valid));
      root.querySelector('[data-bkb-error]').hidden = valid;
      root.querySelector('[data-bkb-minus]').disabled = !valid || count <= config.minimum;
      root.querySelector('[data-bkb-plus]').disabled = !valid;
      const variant = config.variants.find(v => String(v.id) === variantSelect.value);
      const choices = controls.map((control,index) => components[index].choices[Number(control.value)]);
      const creatorAction=root.querySelector('[data-bkb-creator]');
      if(creatorAction)[creatorAction,...document.querySelectorAll('[data-bkb-delivery-creator]')].forEach(action=>{
        const link=new URL(action.getAttribute('href'),'https://hoopsking.com');
        link.searchParams.set('quantity',String(valid?count:config.minimum));
        link.searchParams.set('materials',JSON.stringify(controls.map(control=>Number(control.value))));
        link.searchParams.set('variant',variantSelect.value);
        if(packageConfig?.sku)link.searchParams.set('style',packageConfig.sku);
        action.href=link.pathname+link.search;
      });
      const upgrade = choices.reduce((sum,c) => sum + (Number(c?.add) || 0),0);
      const review = choices.some(c => !c || c.review_required || c.add == null);
      const base = tierPrice(valid ? count : config.minimum);
      const unit = base == null || review ? null : base + upgrade;
      root.querySelector('[data-bkb-unit-price]').textContent = unit == null ? 'Quote confirmed in Creator' : money(unit);
      root.querySelector('[data-bkb-estimate-label]').textContent = valid && unit != null ? `${count} × ${money(unit)}` : `Minimum ${config.minimum}; final quote in Creator`;
      root.querySelector('[data-bkb-total]').textContent = valid && unit != null ? money(count * unit) : '—';
      root.querySelector('[data-bkb-sku]').textContent = variant?.sku || '';
      root.querySelectorAll('[data-bkb-order]').forEach(action => {
        const available = config.custom || !!variant?.available;
        action.setAttribute('aria-disabled', String(!valid || !available));
        if (action.tagName === 'BUTTON') action.disabled = !valid || !available;
      });
    }
    function commit() {
      const raw = qty.value, number = Number(raw);
      if (!raw.trim() || !Number.isSafeInteger(number) || number < config.minimum) {
        const fixed = raw.trim() && Number.isFinite(number) ? Math.max(config.minimum,Math.ceil(number)) : lastValid;
        qty.value = String(Number.isSafeInteger(fixed) ? fixed : config.minimum);
        root.querySelector('[data-bkb-status]').textContent = `Quantity set to ${qty.value}. Minimum ${config.minimum}.`;
      }
      update();
    }
    qty.addEventListener('input',update);
    qty.addEventListener('change',commit);
    qty.addEventListener('blur',commit);
    variantSelect.addEventListener('change',variantChanged);
    root.querySelector('[data-bkb-minus]').addEventListener('click',() => {qty.value = String(Math.max(config.minimum,lastValid-1)); update();});
    root.querySelector('[data-bkb-plus]').addEventListener('click',() => {qty.value = String(lastValid+1); update();});
    root.querySelectorAll('[data-bkb-order]').forEach(action => action.addEventListener('click',event => {update();if(action.getAttribute('aria-disabled') === 'true'){event.preventDefault();qty.reportValidity();qty.focus();}}));
    root.querySelector('form').addEventListener('submit',event => {event.preventDefault();update();if(!qty.checkValidity())qty.reportValidity();});
    const thumbs = [...root.querySelectorAll('[data-bkb-image]')];
    const activeImage=root.querySelector('.hk-bkb-active-image');if(activeImage)activeImage.alt=readable(activeImage.alt);
    root.querySelector('[data-bkb-transcript]').textContent = readable(root.querySelector('[data-bkb-transcript]').textContent);
    thumbs.forEach(button => { button.dataset.alt = readable(button.dataset.alt); });
    thumbs.forEach((button,index) => button.addEventListener('click',() => {
      const image = root.querySelector('.hk-bkb-active-image');
      image.removeAttribute('srcset'); image.src = button.dataset.src; image.alt = button.dataset.alt;
      thumbs.forEach(b => b.setAttribute('aria-pressed',String(b === button)));
      root.querySelector('[data-bkb-transcript]').textContent = button.dataset.alt;
      root.querySelector('[data-bkb-photo-status]').textContent = `Image ${index+1} of ${thumbs.length}`;
    }));
    variantChanged();
  });
})();
